<template>
  <div>
    <single-response-item
      v-if="['color', 'single', 'singleBubble'].includes(question.type)"
      :questionId="questionId"
    />
    <multiple-response-item
      v-if="['multipleBubble'].includes(question.type)"
      :questionId="questionId"
    />
  </div>
</template>

<script>
import MultipleResponseItem from './MultipleResponseItem'
import SingleResponseItem from './SingleResponseItem'

export default {
  name: 'ResponseItem',
  components: { MultipleResponseItem, SingleResponseItem },
  props: {
    questionId: String
  },
  computed: {
    question() {
      return this.$store.state.quiz.question.byId[this.questionId]
    }
  }
}
</script>

<style lang="scss" scoped></style>
